'use client'

import UIText from '@components/ui/UIText'
import UITextarea from '@components/ui/UITextarea'
import { TextareaProps } from '@mui/joy'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import { useState } from 'react'

const TextLimits = ({ valueLength, maxLength }: { valueLength: number; maxLength: number }) => {
	return (
		<UIText
			level="Footnote"
			sx={{
				display: 'flex',
				width: '100%',
				justifyContent: 'end',
				color: color.colGray5,
				fontSize: pxToRem(13),
				lineHeight: pxToRem(18),
				fontWeight: 500,
			}}
		>
			{valueLength.toLocaleString()}/{maxLength.toLocaleString()}자
		</UIText>
	)
}

interface PollTextareaProps {
	sx?: TextareaProps['sx']
	onChange?: (value: string) => void
}
const PollTextarea = ({ sx, onChange }: PollTextareaProps) => {
	const [textAreaValue, setTextAreaValue] = useState('')
	const handleChange = (
		e: React.ChangeEvent<HTMLInputElement> & React.ChangeEvent<HTMLTextAreaElement>,
	) => {
		setTextAreaValue(e.target.value)
		onChange?.(e.target.value)
	}
	return (
		<UITextarea
			value={textAreaValue}
			onChange={handleChange}
			className="poll-textarea"
			placeholder="의견을 입력해주세요"
			slotProps={{ textarea: { maxLength: 100 } }}
			endDecorator={<TextLimits valueLength={textAreaValue.length} maxLength={100} />}
			sx={{
				width: '100%',
				py: pxToRem(10),
				pl: pxToRem(16),
				textarea: {
					paddingInlineEnd: pxToRem(16),
				},
				'.MuiTextarea-endDecorator': {
					marginBlockStart: pxToRem(8),
					marginInlineEnd: pxToRem(16),
				},
				...sx,
			}}
		/>
	)
}

export default PollTextarea
